export { default } from './AddressList';



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/HomeAddress/AddressList/index.js